import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-imported-csv',
  templateUrl: './imported-csv.component.html'
})
export class ImportedCsvComponent implements OnInit {
  constructor(private _route: ActivatedRoute, private _router: Router) {}

  ngOnInit(): void {
    const discoverytype = this._route.snapshot.params['discoverytype'];
    const reportid = this._route.snapshot.params['reportid'];

    if (discoverytype === 'apps') {
      // https://stg-ratings2.pixalate.com/discovery/apps/dashboard/all/GLOBAL/GLOBAL?bulkUploadReportId=1581168745375
      this._router.navigate(
        ['/discovery', 'apps', 'dashboard', 'all', 'GLOBAL', 'GLOBAL' + ''],
        { queryParams: { bulkUploadReportId: reportid } }
      );
    } else if (discoverytype === 'ctvs') {
      this._router.navigate(
        ['/discovery', 'ctv', 'list', 'all', 'GLOBAL', 'GLOBAL'],
        { queryParams: { bulkUploadReportId: reportid } }
      );
    } else {
      // https://stg-ratings2.pixalate.com/discovery/domains/dashboard/GLOBAL/GLOBAL/F?bulkUploadReportId=1581752476135
      this._router.navigate(
        ['/discovery', 'domains', 'dashboard', 'GLOBAL', 'GLOBAL', 'F'],
        { queryParams: { bulkUploadReportId: reportid } }
      );
    }
  }
}
